import { RawDraftContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import React from 'react';
import { isDesktop, isMobile } from 'react-device-detect';
import { Link, useSearchParams } from 'react-router-dom';
import ReactTimeAgo from 'react-time-ago';

import BotaoLink from 'Component/BotaoLink';
import Icone from 'Component/Icone';
import Paginacao from 'Component/Paginacao';
import SemRegistros from 'Component/SemRegistros';
import { useRecuperarSolicitacoesQuery } from 'View/Service/Default/Solicitacoes';

const Default = (): React.ReactElement => {
  const [searchParams] = useSearchParams();

  const { data: { solicitacoes, paginacao } = {}, isFetching } =
    useRecuperarSolicitacoesQuery({
      contain: ['Atendentes'],
      sort: 'Solicitacoes.criado',
      direction: 'desc',
      page: searchParams.get('pagina') || 1,
    });

  return (
    <div
      className="animate__animated animate__fadeIn"
      style={{ minHeight: window.outerHeight }}
    >
      <div
        className="hf-400 d-flex align-items-end pb-5"
        style={{
          backgroundImage:
            'linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 100%), url(/img/meus-cursos.jpg)',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          marginTop: '-130px',
        }}
      >
        <div className="container text-center">
          <h1 className="display-2 text-white">Tem algum problema?</h1>
          <p className="lead text-muted">
            Não se preocupa que a gente te ajuda. É só abrir uma solicitação!
          </p>
        </div>
      </div>
      <div className="mx-3">
        <div className="container mb-5">
          <SemRegistros
            carregando={isFetching}
            registros={solicitacoes?.length}
            titulo="Nenhuma solicitação encontrada"
          />
          {solicitacoes && solicitacoes.length > 0 && (
            <div className="list-group border border-dark">
              {solicitacoes.map((solicitacao, index) => (
                <Link
                  key={`${solicitacao.id}-${solicitacao.modificado}`}
                  to={`/estudar/solicitacoes/${solicitacao.id}`}
                  className={`list-group-item list-group-item-action bg-black ${
                    index
                      ? 'border-top border-dark border-start-0 border-end-0 border-bottom-0'
                      : ''
                  }`}
                >
                  <div className="d-flex w-100 justify-content-between gap-2">
                    <h5 className="mb-1 text-muted">{solicitacao.titulo}</h5>
                    <small className="text-muted text-nowrap">
                      <ReactTimeAgo
                        date={solicitacao.criado.data().toJSDate()}
                      />
                    </small>
                  </div>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: draftToHtml(
                        solicitacao.descricao as unknown as RawDraftContentState
                      ),
                    }}
                    className="mb-1 text-white"
                  />
                  <small className="text-muted">
                    {solicitacao.status == 0 && (
                      <React.Fragment>
                        <Icone nome="clock" className="me-3 text-secondary" />
                        Aguardando atendimento
                      </React.Fragment>
                    )}
                    {solicitacao.status == 1 && (
                      <React.Fragment>
                        <Icone nome="display" className="me-3 text-primary" />
                        Em atendimento por {solicitacao.atendente?.nome}
                      </React.Fragment>
                    )}
                    {solicitacao.status == 2 && (
                      <React.Fragment>
                        <Icone
                          nome="check-circle-fill"
                          className="me-3 text-success"
                        />
                        Finalizado
                      </React.Fragment>
                    )}
                  </small>
                </Link>
              ))}
            </div>
          )}
          <Paginacao dados={paginacao} desabilitado={isFetching} />
          <div
            className="position-fixed end-0 pe-4 z-index-5000"
            style={{ bottom: isMobile ? 130 : 30 }}
          >
            <BotaoLink
              lg
              circulo={isDesktop ? false : true}
              icone="plus"
              to="/estudar/solicitacoes/adicionar"
              texto={isDesktop ? 'Abrir solicitação' : ''}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Default;
